export default __webpack_public_path__ + "static/media/drapeau_can.3192a5d3.png";